import { floor } from 'lodash';
import * as moment from 'moment';

import { InspectionRecurrencePeriod } from '@main-application/inspections/models/rest-inspections-model.interface';
import { IRadioButtonOption } from '@shared/interfaces/radio-button-option.interface';

export const GetRecurrencePeriodTypeList = (dueDate: Date): IRadioButtonOption<InspectionRecurrencePeriod>[] => {
  if (!dueDate) {
    return [];
  }
  const dayOfWeek = moment(dueDate).format('dddd');
  const weekNumber = floor(dueDate.getDate() / 7) + 1;
  let weekNumberText = 'N/A';

  switch (weekNumber) {
    case 1:
      weekNumberText = 'first';
      break;
    case 2:
      weekNumberText = 'second';
      break;
    case 3:
      weekNumberText = 'third';
      break;
    case 4:
      weekNumberText = 'fourth';
      break;
    default:
      weekNumberText = 'N/A';
  }

  const today = moment(dueDate).format('MMMM D');
  const semi1 = moment(dueDate).format('MMM D');
  const semi2 = moment(dueDate).add(7, 'month').format('MMM D');
  return [
    {
      value: InspectionRecurrencePeriod.DoNotRepeat,
      label: 'Does not repeat',
    },
    {
      value: InspectionRecurrencePeriod.Daily,
      label: 'Weekdays',
    },
    {
      value: InspectionRecurrencePeriod.Weekly,
      label: `Weekly on ${dayOfWeek}`,
    },
    {
      value: InspectionRecurrencePeriod.SemiMonthly,
      label: `Semi-monthly every other ${dayOfWeek}`,
    },
    {
      value: InspectionRecurrencePeriod.Monthly,
      label: `Monthly on the first ${dayOfWeek}`,
    },
    weekNumber == 1
      ? null
      : {
          value: InspectionRecurrencePeriod.SameWeekMonthly,
          label: `Monthly on the ${weekNumberText} ${dayOfWeek}`,
        },
    {
      value: InspectionRecurrencePeriod.SemiAnnually,
      label: `Semi-annually on ${semi1} and ${semi2}`,
    },
    {
      value: InspectionRecurrencePeriod.Quarterly,
      label: `Quarterly on the first ${dayOfWeek}`,
    },
    weekNumber == 1
      ? null
      : {
          value: InspectionRecurrencePeriod.SameWeekQuarterly,
          label: `Quarterly on the ${weekNumberText} ${dayOfWeek}`,
        },
    {
      value: InspectionRecurrencePeriod.Annually,
      label: `Annually on ${today}`,
    },
  ].filter(x => x != null);
};
